<template>
  <div class="step-identity-confirm">
    <div
      class="identityVerification passWordReg"
      v-if="approveType === 'password'"
    >
      <p class="userInfo">
        <span></span>
        <span class="aLink uiGreen" @click="handleSwitchAuth">
          {{ $fanyi("其他认证方式") }}
        </span>
      </p>
      <el-form
        ref="pwdFormRef"
        class="identity-form"
        :model="formModel"
        :rules="pwdRules"
        label-width="auto"
      >
        <el-form-item
          prop="oldPassword"
          :label="$fanyi('请输入登录密码') + '：'"
        >
          <el-input
            type="password"
            v-model="formModel.oldPassword"
            autocomplete="new-password"
            :placeholder="$fanyi('请输入登录密码')"
            class="uiInput"
          />
        </el-form-item>
      </el-form>
      <el-button class="uiBtn nextBtn " @click="handlePasswordNext">
        {{ $fanyi("下一步") }}
      </el-button>
    </div>

    <div class="identityVerification" v-else>
      <p class="userInfo">
        <span>
          {{
            approveType === "mobile" ? $fanyi("手机号码") : $fanyi("邮箱")
          }}：{{ approveType === "mobile" ? userMobile : userEmail }}</span
        >
        <span class="aLink uiGreen" @click="handleSwitchAuth">
          {{ $fanyi("其他认证方式") }}
        </span>
      </p>

      <el-form
        ref="verifyFormRef"
        class="identity-form"
        :model="formModel"
        :rules="verifyRules"
        label-width="auto"
      >
        <el-form-item prop="regCode" :label="$fanyi('验证码') + '：'">
          <div class="dip">
            <el-input v-model="formModel.regCode" type="text" class="uiInput" />
            <div class="verify-actions">
              <el-button
                class="uiBtn uiGreen"
                v-if="showBtn"
                @click.prevent="sendVerificationCode"
              >
                {{ $fanyi("验证码获取") }}
              </el-button>
              <el-button v-else class="uiBtn sixSec uiGreen" @click.prevent>
                {{ Countdown }} S
              </el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <el-button class="uiBtn nextBtn " @click="handleVerificationNext">
        {{ $fanyi("下一步") }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepIdentityConfirm",
  props: {
    approveType: { type: String, required: true },
    changeType: { type: String, default: "" },
    loginName: { type: String, default: "" },
  },
  data() {
    return {
      formModel: {
        oldPassword: "",
        regCode: "",
      },
      showBtn: true,
      Countdown: 60,
      codeTimer: null,
      pwdRules: {
        oldPassword: [
          {
            required: true,
            message: this.$fanyi("请输入登录密码"),
            trigger: "blur",
          },
        ],
      },
      verifyRules: {
        regCode: [
          {
            required: true,
            message: this.$fanyi("请输入验证码"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    userMobile() {
      return this.$store.state.userInfo.mobile;
    },
    userEmail() {
      return this.$store.state.userInfo.email;
    },
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    getModifyOccasion() {
      const map = {
        email: "modify_email",
        mobile: "modify_mobile",
        password: "modify_password",
      };
      return map[this.changeType] || "modify_password";
    },
    contactForSendApi() {
      const raw =
        this.approveType === "mobile" ? this.userMobile : this.userEmail;
      if (this.approveType === "mobile" && raw && raw.substr(0, 1) === "+") {
        return raw.substr(3);
      }
      return raw;
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
    },
    handleSwitchAuth() {
      this.formModel.oldPassword = "";
      this.formModel.regCode = "";
      this.clearCodeTimer();
      this.showBtn = true;
      this.Countdown = 60;
      this.$emit("reset-methods");
    },
    sendVerificationCode() {
      const number = this.contactForSendApi();
      const datas = {
        occasion: this.getModifyOccasion(),
        tool: this.approveType,
        number,
        login_name: this.loginName,
      };
      if (this.approveType === "mobile") {
        datas.area_code = this.$store.state.userInfo.country_phone || "+39";
      }
      this.showBtn = false;
      this.Countdown = 60;
      this.clearCodeTimer();
      this.$api.sendVerificationCode(datas).then((res) => {
        this.showBtn = true;
        if (res.code != 0) return this.$message.error(this.$fanyi("操作失败"));
        this.showBtn = false;
        this.Countdown = 60;
        this.codeTimer = setInterval(() => {
          this.Countdown--;
          if (this.Countdown <= 0) {
            this.showBtn = true;
            this.Countdown = 60;
            this.clearCodeTimer();
          }
        }, 1000);
      });
    },
    checkIdentityVerificationCode(done) {
      const datas = {
        occasion: this.getModifyOccasion(),
        number: this.contactForSendApi(),
        code: this.formModel.regCode,
      };
      if (!datas.number) {
        return this.$message(this.$fanyi("重要参数为空"));
      }
      this.$api.checkVerificationCode(datas).then((res) => {
        if (res.success == true) {
          this.clearCodeTimer();
          this.showBtn = true;
          this.Countdown = 60;
          done();
        } else {
          this.$message.warning(this.$fanyi("验证码错误"));
        }
      });
    },
    emitComplete() {
      this.$emit("complete", {
        oldPassword: this.formModel.oldPassword,
        regCode: this.formModel.regCode,
      });
    },
    handlePasswordNext() {
      this.$refs.pwdFormRef.validate((valid) => {
        if (!valid) return;
        this.$api
          .userCheckPassword({
            password: this.formModel.oldPassword,
          })
          .then((res) => {
            if (res.data != true) {
              return this.$message.error(this.$fanyi("密码错误"));
            }
            this.emitComplete();
          });
      });
    },
    handleVerificationNext() {
      this.$refs.verifyFormRef.validate((valid) => {
        if (!valid) return;
        this.checkIdentityVerificationCode(() => this.emitComplete());
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/css/mixin.scss";

.step-identity-confirm {
  .identityVerification {
    &.passWordReg {
      .password {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .userInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      span {
        font-size: 18px;
        color: #000000;
        line-height: 24px;
      }
      .aLink.uiGreen {
        font-size: 16px;
        color: #009246;
        line-height: 20px;
        cursor: pointer;
      }
    }

    .identity-form {
      margin-bottom: 40px;
    }

    .verify-actions {
      margin-left: 16px;
      .el-button {
        height: 40px;
        padding: 0 16px;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .uiInput {
      width: 400px;
      height: 40px;
    }
    /deep/ .uiInput .el-input__inner {
      height: 40px;
      line-height: 40px;
    }
    .uiSelect {
      width: 400px;
      height: 40px;
    }
  }
}
</style>
